function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "interview",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_308",
  "data-name": "Path 308",
  d: "M28.355,1.7A5.819,5.819,0,0,0,18.42,5.724L16.836,4.141,9.622,11.355l1.829,1.829L.612,24.723l1.733,1.733L0,28.8l1.256,1.256L3.6,27.713l1.733,1.733,11.54-10.839L18.7,20.435l7.214-7.214-1.583-1.583A5.819,5.819,0,0,0,28.355,1.7ZM5.373,26.971,3.086,24.685l9.622-10.244,2.909,2.909ZM18.7,17.922l-6.567-6.567,4.7-4.7L23.4,13.221Zm8.4-9.241a4.051,4.051,0,0,1-5.721,0l0,0a4.046,4.046,0,1,1,5.723,0Z",
  transform: "translate(0 0)",
  fill: "#ac1ede"
}));

var SvgInterview = function SvgInterview(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.058,
    height: 30.058,
    viewBox: "0 0 30.058 30.058",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInterview, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/interview.fa99d7bc.svg";
export { ForwardRef as ReactComponent };